import { Link, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import type { PortalHostRouter } from '@hopdrive/feature-portal-products';

/** The product model's router port, bound to react-router. A module constant, so the host value
 * that carries it stays referentially stable. */
export const REACT_ROUTER_PORT: PortalHostRouter = { useLocation, useNavigate, useParams, Link, Outlet };
